module.exports = __webpack_public_path__ + "8b2c68b8dffabc7c0822e7f1d491b72e.MP3";